
import ResidentListVerticalTab from "../../../components/business/resident/residentListVerticalTab";
import Portal from "../../../../../platform/pages/business/portal";
import { Alert, Box } from "@mui/material";
import { useQuery } from "@apollo/client";
import { usePermissions } from "../../../../../platform/hooks/usePermissions";
import { Permissions } from "../../../../../platform/util/accessControl";
import { GET_BUSINESS_CATEGORIES } from "../../../../../platform/graphql/queries";
import { useSelectedBusiness } from "../../../../../platform/redux/store";
import { isAFHCategoryName } from "../../../../../platform/pages/business/defaultPageDialog";
const ResidentPortal = (props: any) => {
  const selectedBusiness = useSelectedBusiness();
  const { data: categoriesData } = useQuery(GET_BUSINESS_CATEGORIES);
  const selectedCategory = (categoriesData?.getBusinessCategories || []).find(
    (c: any) =>
      Number(c?.id) === Number(selectedBusiness?.businessBasic?.businessCategoryId)
  );
  const isAFHBusiness = isAFHCategoryName(selectedCategory?.name);
  const { checkPermission } = usePermissions();
  const canViewResidents =
    isAFHBusiness ||
    checkPermission(Permissions.Resident.VIEW) ||
    checkPermission(Permissions.Business.VIEW);

  if (!canViewResidents) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">You do not have permission to view Residents.</Alert>
      </Box>
    );
  }
  return <Portal TabComponent={ResidentListVerticalTab} title={"Team members"} props={props} />;
};
export default ResidentPortal;

